import { render, staticRenderFns } from "./IconUploadOutline.vue?vue&type=template&id=213b2a30"
import script from "./IconUploadOutline.vue?vue&type=script&lang=js"
export * from "./IconUploadOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports